import React from 'react';

import { Layout as AntdLayout } from 'antd';
import AccountMenuLeft from '../components/Account/AccountMenuLeft';
import AccountProfile from '../components/Account/AccountProfile';
import { useSelector } from 'react-redux';
import { IState } from '../graphql/types';
import AccountSettings from '../components/Account/AccountSettings';
import AccountBilling from '../components/Account/AccountBilling';
import AccountNotifications from '../components/Account/AccountNotifications';
import AccountPassword from '../components/Account/AccountPassword';
import AccountSubscription from '../components/Account/AccountSubscription';
import { colors } from '../theme';

// import AccountMenuRight from '../components/Account/AccountMenuRight';

const Account: React.FC = () => {
  const accountPage = useSelector<IState, string | undefined>(
    state => state.accountPage
  );

  return (
    <>
      <AntdLayout.Sider
        theme={'light'}
        width="167pt"
        style={{ borderRight: '1px solid ' + colors.white3 }}
      >
        <AccountMenuLeft />
      </AntdLayout.Sider>
      <AntdLayout.Content>
        {accountPage === 'Profile' ? (
          <AccountProfile />
        ) : accountPage === 'Password' ? (
          <AccountPassword />
        ) : accountPage === 'Settings' ? (
          <AccountSettings />
        ) : accountPage === 'Billing' ? (
          <AccountBilling />
        ) : accountPage === 'Notifications' ? (
          <AccountNotifications />
        ) : accountPage === 'Subscription' ? (
          <AccountSubscription />
        ) : null}
      </AntdLayout.Content>
    </>
  );
};

export default Account;
